import { AnyAction, CombinedState, Store } from 'redux';
import { RootState } from '../../redux/root-reducer';


/*
 * Store reference to avoid circular dependencies issue..
 */
class StoreRegistry {
  store: Store<CombinedState<RootState>, AnyAction> & { dispatch: unknown; } = {} as any;

  register = (store: any) => {
    this.store = store;
  }
}

export const StoreRegistryHelper = new StoreRegistry();
